export const ruContent = {
  introduction: {
    content: [
      "С момента своего дебюта в 1996 году серия Покемон завоевала сердца игроков по всему миру, став одним из самых популярных развлекательных брендов. Наш генератор случайных покемонов разработан для тренеров всех возрастов, будь то желание открыть новых покемонов, собрать сбалансированную команду или просто насладиться сюрпризами в путешествии по миру покемонов.",
      "Независимо от того, являетесь ли вы опытным игроком, ищущим вдохновение для следующего соревнования, или казуальным игроком, стремящимся расширить свой Покедекс, этот инструмент генерации случайных покемонов предоставит вам увлекательный и интерактивный способ исследовать обширный мир покемонов."
    ]
  },
  howToUse: {
    content: [
      "Использование нашего селектора случайных покемонов просто и интуитивно понятно. Следуйте этим шагам, чтобы начать создавать свою идеальную команду покемонов:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Выберите количество покемонов: определите, сколько покемонов вы хотите сгенерировать (1-8)." },
          { type: "text", content: "Выберите тип: отфильтруйте конкретные типы покемонов, такие как огненный, водный, электрический и т.д., или выберите \"любой\" для включения всех типов." },
          { type: "text", content: "Выберите поколение: выберите любое поколение с первого по восьмое или \"любое\" для включения покемонов из всех поколений." },
          { type: "text", content: "Установите редкость: определите уровень редкости генерируемых покемонов." },
          { type: "text", content: "Нажмите \"Генерировать\": после установки предпочтений нажмите кнопку для генерации покемонов." },
          { type: "text", content: "Исследуйте результаты: просмотрите подробную информацию о каждом покемоне, включая базовые характеристики, способности, типы и многое другое!" }
        ]
      },
      "Вы можете в любое время настроить параметры и попробовать несколько раз, чтобы открыть различные комбинации покемонов."
    ]
  },
  benefits: {
    content: [
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Полностью бесплатно: наш генератор случайных покемонов абсолютно бесплатен, без скрытых платежей или требований подписки." },
          { type: "text", content: "Настраиваемый опыт: настройте свой случайный выбор по типу, поколению и редкости." },
          { type: "text", content: "Образовательный инструмент: изучайте базовые характеристики, способности и типы различных покемонов." },
          { type: "text", content: "Помощник по сборке команды: быстро создавайте сбалансированные команды для казуальных или соревновательных боёв." },
          { type: "text", content: "Создатель испытаний: создавайте уникальные игровые испытания, ограничивая себя случайно сгенерированными покемонами." },
          { type: "text", content: "Без аккаунта: начните использовать инструмент немедленно, без необходимости регистрации или предоставления личной информации." }
        ]
      }
    ]
  },
  history: {
    content: [
      "Серия Покемон началась в 1996 году, когда Сатоси Тадзири создал первую игру для Nintendo Game Boy. Вдохновлённый своим детским увлечением коллекционированием насекомых, концепция вращалась вокруг ловли, тренировки и сражений с существами, известными как \"Карманные монстры\" (Pocket Monsters) или покемоны.",
      "Ключевые вехи в истории Покемон включают:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "1996: Выпуск оригинальных игр Pokémon Red и Green в Японии" },
          { type: "text", content: "1998: Международный релиз Pokémon Red и Blue" },
          { type: "text", content: "1999: Глобальный запуск коллекционной карточной игры Покемон" },
          { type: "text", content: "2000: Выпуск Pokémon Gold и Silver с добавлением 100 новых покемонов" },
          { type: "text", content: "2016: Запуск Pokémon GO, выводящий серию на мобильные платформы" },
          { type: "text", content: "2019: Выпуск Pokémon Sword и Shield на Nintendo Switch" }
        ]
      },
      "Сегодня, с более чем 900 различными покемонами через восемь поколений, серия расширилась, включая видеоигры, коллекционные карточные игры, аниме-сериалы, фильмы, товары и мобильные приложения, став одной из самых прибыльных медиафраншиз всех времён."
    ]
  },
  popularPokemon: {
    content: [
      "В истории Покемон некоторые покемоны стали культовыми символами серии:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Пикачу: электрический талисман серии, известный своим молниеобразным хвостом и красными щёчками." },
          { type: "text", content: "Чаризард: любимый фанатами огненный/летающий покемон, известный своим драконоподобным видом и мощью." },
          { type: "text", content: "Мьюту: легендарный покемон психического типа, созданный путём генетических экспериментов с Мью, известный своей невероятной силой." },
          { type: "text", content: "Иви: любимый за свою уникальную способность эволюционировать в различные формы, включая Вапореон, Джолтеон и Флареон." },
          { type: "text", content: "Гярадос: могучий водный/летающий покемон, эволюционировавший из слабого Мэджикарпа." },
          { type: "text", content: "Лукарио: боевой/стальной покемон, известный своей силой ауры и популярностью в соревновательных боях." },
          { type: "text", content: "Грениндзя: водный/тёмный покемон-ниндзя, получивший популярность благодаря аниме-сериалу." }
        ]
      },
      "Наш генератор случайных покемонов даёт вам возможность открыть для себя эти культовые виды, а также множество других не менее увлекательных, но менее известных покемонов."
    ]
  },
  popularGames: {
    content: [
      "Серия игр Покемон выпустила множество популярных тайтлов на различных платформах:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Pokémon Red, Blue и Yellow: оригинальные игры, начавшие легенду на Game Boy." },
          { type: "text", content: "Pokémon Gold, Silver и Crystal: представили регион Джото и систему смены дня и ночи." },
          { type: "text", content: "Pokémon Ruby, Sapphire и Emerald: расширили игровой мир регионом Хоэнн и двойными битвами." },
          { type: "text", content: "Pokémon Diamond, Pearl и Platinum: вывели серию на Nintendo DS с онлайн-функциями." },
          { type: "text", content: "Pokémon Black и White: представили полностью новый состав покемонов с акцентом на сюжет." },
          { type: "text", content: "Pokémon X и Y: ввели 3D-модели и мега-эволюцию." },
          { type: "text", content: "Pokémon Sun и Moon: переосмыслили систему гимов с испытаниями на островах." },
          { type: "text", content: "Pokémon GO: мобильная игра с дополненной реальностью, ставшая глобальным феноменом." },
          { type: "text", content: "Pokémon Sword и Shield: вывели серию на Nintendo Switch с концепцией Дикой местности." },
          { type: "text", content: "Pokémon Legends: Arceus: первая попытка серии в жанре открытого мира." }
        ]
      },
      "Каждая игра вводила новые механики и покемонов, расширяя мир покемонов, который можно исследовать с помощью нашего генератора случайных покемонов."
    ]
  },
  tradingContests: {
    content: [
      "Обмен покемонами был фундаментальной особенностью серии с самого начала. Оригинальные игры выпускались парами специально для поощрения обмена покемонами между друзьями для заполнения Покедекса. Этот социальный элемент помог распространить популярность Покемон и остаётся важным по сей день.",
      "Ключевые аспекты обмена включают:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Эксклюзивные для версии покемоны, доступные только через обмен" },
          { type: "text", content: "Некоторые покемоны, такие как Мачамп и Генгар, эволюционируют только через обмен" },
          { type: "text", content: "Глобальная система обмена (GTS) в современных играх позволяет обмениваться по всему миру" },
          { type: "text", content: "Обмен редкими или сияющими покемонами как символ статуса" }
        ]
      },
      "Покемон-контесты, введённые в третьем поколении, предоставили альтернативный способ соревнования, где покемоны соревнуются по внешнему виду, выступлению и обаянию, а не боевой силе. Эти конкурсы включают:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Различные категории конкурсов (крутость, красота, милота, умность, сила)" },
          { type: "text", content: "Специальные приёмы, разработанные для конкурсов" },
          { type: "text", content: "Управление состоянием покемонов через ягоды и пуфы" },
          { type: "text", content: "Многоэтапные соревнования с предварительной визуальной оценкой и раундами выступлений" }
        ]
      },
      "Наш генератор случайных покемонов может помочь вам открыть покемонов, которые отлично выступают в конкурсах или становятся ценными партнёрами для обмена, добавляя новое измерение вашему опыту с покемонами."
    ]
  },
  faq: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Этот генератор случайных покемонов бесплатный?",
            answer: "Да, наш инструмент полностью бесплатный, без каких-либо скрытых платежей или требований подписки."
          },
          {
            type: "faq",
            question: "Насколько точны данные о покемонах?",
            answer: "Все данные о покемонах поступают из официального PokéAPI, обеспечивая точность и своевременные обновления."
          },
          {
            type: "faq",
            question: "Могу ли я генерировать покемонов из определённого поколения?",
            answer: "Да, вы можете выбрать любое поколение с первого по восьмое или \"любое\" для включения всех поколений."
          },
          {
            type: "faq",
            question: "Как работает фильтр редкости?",
            answer: "Наш алгоритм присваивает каждому покемону значение редкости от 1 до 10 на основе легендарного/мифического статуса, базового опыта и других факторов."
          },
          {
            type: "faq",
            question: "Могу ли я сохранить или экспортировать сгенерированных покемонов?",
            answer: "В настоящее время вы можете сделать скриншот результатов. Мы рассматриваем возможность добавления функции сохранения/экспорта в будущих обновлениях."
          },
          {
            type: "faq",
            question: "Поддерживает ли генератор случайных покемонов мобильные устройства?",
            answer: "Да, наш генератор полностью поддерживает адаптивный дизайн и может использоваться на смартфонах, планшетах и компьютерах."
          }
        ]
      }
    ]
  },
  conclusion: {
    content: [
      "Наш генератор случайных покемонов предлагает бесконечные возможности как для обычных фанатов, так и для опытных тренеров. Хотите ли вы найти новых фаворитов, создать тематическую команду или испытать себя с неожиданными комбинациями, наш инструмент предоставляет веселый и образовательный способ исследовать обширный мир покемонов.",
      "Мы постоянно работаем над улучшением генератора, добавляя новые функции и опции. Попробуйте сегодня, установите свои предпочтения и нажмите \"Создать\", чтобы увидеть, какие покемоны вас ждут!",
      "Делитесь своими результатами с друзьями и другими тренерами, и расскажите нам, как вы используете генератор случайных покемонов в своем путешествии с покемонами. Приятных открытий!"
    ]
  },
  // Разделы содержания "На какого покемона я похож?"
  whichPokemonIntro: {
    content: [
      "Вы когда-нибудь задумывались, на какого покемона вы больше всего похожи? Наш инструмент \"На какого покемона я похож?\" предлагает веселый и уникальный способ найти своего покемона-двойника на основе ваших физических характеристик.",
      "Эта инновационная функция анализирует ваш рост и вес, чтобы определить покемона, который наиболее близок к вашим пропорциям. Независимо от того, высоки ли вы как Чаризард или компактны как Пикачу, наш алгоритм находит вашего идеального покемона с удивительной точностью."
    ]
  },
  whichPokemonHowToUse: {
    content: [
      "Использование нашего инструмента \"На какого покемона я похож?\" очень просто и занимает всего несколько секунд. Следуйте этим простым шагам, чтобы найти своего покемона:",
      {
        type: "orderedList",
        items: [
          { type: "text", content: "Введите свое имя (или прозвище) в предоставленную форму." },
          { type: "text", content: "Введите свой рост в сантиметрах (см)." },
          { type: "text", content: "Введите свой вес в килограммах (кг)." },
          { type: "text", content: "Нажмите кнопку \"Найти моего покемона\", чтобы увидеть результаты." },
          { type: "text", content: "Посмотрите на своего совпадающего покемона, включая имя, тип, размер, вес и оценку сходства." },
          { type: "text", content: "Поделитесь своими результатами в социальных сетях или загрузите их как изображение, чтобы показать друзьям!" }
        ]
      },
      "Оценка сходства показывает, насколько близки ваши пропорции к пропорциям покемона. Чем выше процент, тем ближе совпадение!"
    ]
  },
  whichPokemonBenefits: {
    content: [
      "Обнаружение своего покемона-двойника предлагает больше, чем просто развлечение:",
      {
        type: "unorderedList",
        items: [
          { type: "text", content: "Веселый способ обучения: Открывайте и изучайте новых покемонов, которые соответствуют вашим физическим характеристикам." },
          { type: "text", content: "Уникальная перспектива: Посмотрите на себя через призму мира покемонов." },
          { type: "text", content: "Начало разговора: Поделитесь своими результатами с друзьями и сравните, какой покемон подходит каждому из вас." },
          { type: "text", content: "Вдохновение для косплея: Найдите покемона, который естественным образом соответствует вашему типу телосложения, для идей косплея." },
          { type: "text", content: "Создание команды: Создайте тематическую команду в играх про покемонов, основанную на физическом сходстве с вами и вашими друзьями." }
        ]
      }
    ]
  },
  whichPokemonFAQ: {
    content: [
      {
        type: "faqList",
        items: [
          { 
            type: "faq",
            question: "Насколько точен алгоритм сопоставления?",
            answer: "Наш алгоритм использует официальные данные о размерах и весе покемонов из PokéAPI и рассчитывает сходство на основе пропорционального евклидова расстояния. Хотя он разработан больше для развлечения, чем для научной точности, многие пользователи находят совпадения удивительно подходящими!"
          },
          {
            type: "faq",
            question: "Почему инструмент не учитывает другие физические характеристики?",
            answer: "В настоящее время мы сосредоточены на росте и весе для простоты, а также потому, что это наиболее последовательно документированные физические атрибуты для всех видов покемонов. Мы можем добавить больше атрибутов в будущих обновлениях."
          },
          {
            type: "faq",
            question: "Могу ли я сопоставить себя с любым покемоном?",
            answer: "В настоящее время инструмент сопоставляет с оригинальными 151 покемонами (Поколение I) для оптимизации производительности. Мы планируем расширить это в будущих обновлениях, чтобы включить все поколения."
          },
          {
            type: "faq",
            question: "Сохраняются или передаются ли мои личные данные?",
            answer: "Нет, мы не сохраняем ваш рост, вес или другую личную информацию, которую вы вводите. Все вычисления выполняются в вашем браузере, и ничего не отправляется на наши серверы."
          },
          {
            type: "faq",
            question: "Почему у меня получился другой покемон, чем у моего друга с похожими измерениями?",
            answer: "Небольшие различия в соотношении роста и веса могут привести к разным совпадениям. Алгоритм рассматривает пропорции, а не абсолютные значения."
          },
          {
            type: "faq",
            question: "Могу ли я поделиться своими результатами в социальных сетях?",
            answer: "Да! Вы можете загрузить свой результат как изображение или поделиться им напрямую на платформах, таких как Facebook и Twitter, используя предоставленные кнопки."
          }
        ]
      }
    ]
  },
  whichPokemonConclusion: {
    content: [
      "Наш инструмент \"На какого покемона я похож?\" предлагает игривое представление о том, как вы могли бы существовать в удивительном мире покемонов. Хотя он в основном предназначен для развлечения, многие пользователи обнаруживают удивительные связи с личностью или способностями их сопоставленного покемона, выходящие за рамки простого физического сходства.",
      "Попробуйте немного изменить свои данные, чтобы увидеть, как разные рост и вес влияют на ваше совпадение, или вызовите друзей и семью найти своих покемонов-двойников. Вы можете удивиться результатам сопоставления покемонов!",
      "Независимо от того, совпадаете ли вы с величественным легендарным покемоном, мощным стартовым покемоном или недооцененным карманным монстром, примите своего покемона-двойника и уникальные качества, которые вы разделяете. В конце концов, в мире покемонов каждый вид имеет свои особые сильные стороны и значение."
    ]
  }
}; 